import { t } from 'i18next';
import { useRevealOnScroll } from 'src/shared';

const ticIcons = [
  // Official & verified — shield check
  <svg key={0} viewBox="0 0 22 22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 2 3.5 5.5v5c0 4.4 3.2 8.5 7.5 9.5 4.3-1 7.5-5.1 7.5-9.5v-5L11 2z" />
    <path d="m8 11 2 2 4-4" />
  </svg>,
  // Free always — tag/price
  <svg key={1} viewBox="0 0 22 22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12.5 2H7a2 2 0 0 0-2 2v5.5l9 9 7-7z" />
    <circle cx="8" cy="8" r="1.5" fill="currentColor" stroke="none" />
  </svg>,
  // Tracked fairly — bar chart
  <svg key={2} viewBox="0 0 22 22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="20" x2="18" y2="10" />
    <line x1="12" y1="20" x2="12" y2="4" />
    <line x1="6" y1="20" x2="6" y2="14" />
    <line x1="3" y1="20" x2="21" y2="20" />
  </svg>,
  // Real rewards — star/gift
  <svg key={3} viewBox="0 0 22 22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="11 2 13.9 8.3 21 9.3 16 14.1 17.2 21 11 17.8 4.8 21 6 14.1 1 9.3 8.1 8.3 11 2" />
  </svg>,
];

export default function TrustComponent() {
  const headRef = useRevealOnScroll<HTMLDivElement>();
  const item1Ref = useRevealOnScroll<HTMLDivElement>();
  const item2Ref = useRevealOnScroll<HTMLDivElement>();
  const item3Ref = useRevealOnScroll<HTMLDivElement>();
  const item4Ref = useRevealOnScroll<HTMLDivElement>();

  const items = [
    { ref: item1Ref, titleKey: 'joinPage.v2.trust.item1.title', bodyKey: 'joinPage.v2.trust.item1.body' },
    { ref: item2Ref, titleKey: 'joinPage.v2.trust.item2.title', bodyKey: 'joinPage.v2.trust.item2.body' },
    { ref: item3Ref, titleKey: 'joinPage.v2.trust.item3.title', bodyKey: 'joinPage.v2.trust.item3.body' },
    { ref: item4Ref, titleKey: 'joinPage.v2.trust.item4.title', bodyKey: 'joinPage.v2.trust.item4.body' },
  ];

  return (
    <section className="trust section-pad" aria-labelledby="jp-trust-title">
      <div className="wrap">
        <div ref={headRef} className="sec-head reveal" style={{ textAlign: 'center' }}>
          <span className="eyebrow" style={{ justifyContent: 'center' }}>
            <span className="dot" />{t('joinPage.v2.trust.label')}
          </span>
          <h2 className="display" id="jp-trust-title">{t('joinPage.v2.trust.title')}</h2>
        </div>
        <div className="trust__grid">
          {items.map((item, i) => (
            <div key={i} ref={item.ref} className="trust__item reveal">
              <div className="tic" aria-hidden="true">{ticIcons[i]}</div>
              <div>
                <h4>{t(item.titleKey)}</h4>
                <p>{t(item.bodyKey)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
